import { SearchIcon } from '@mote/assets/icons'
import { Input } from '../../input/input'
import { useDataTable } from '../dataTable.context'

export const DataTableSearchBar = () => {
  const { getSearchBarProps } = useDataTable()

  return (
    <Input
      placeholder='Search rows'
      contentLeft={<SearchIcon />}
      maxWidth={400}
      fullWidth
      isClearable
      {...getSearchBarProps()}
    />
  )
}
